import { ApolloClient, InMemoryCache, DefaultOptions } from "@apollo/client";

const uri = "/api/hyvendor/graphql";

const cache = new InMemoryCache({ addTypename: false });

export const client = new ApolloClient({
  uri: uri,
  cache,
  credentials: "include",
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

export const driver = new ApolloClient({
  uri: "http://127.0.0.1:8910/api/hylockerdriver/graphql",
  cache: new InMemoryCache(),
  credentials: "include",
  defaultOptions: defaultOptions,
});
